<svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25">
    <g fill="none" fill-rule="evenodd">
        <path fill="#FFF" d="M9 3h6v18H9z"/>
        <circle cx="12" cy="12" r="12" fill="#E43535"/>
        <g fill="#FFF" transform="translate(10 4)">
            <rect width="2" height="10" x="1" y=".5" rx="1"/>
            <circle cx="2" cy="14" r="1.5"/>
        </g>
    </g>
</svg>
